import type { CrmChatProviderKey } from '@/api/types/crm/crmLeadFunnels.types'
import type { CrmIntegrationMessageDisplay } from '../types/crm-integration-message.types'
import { CRM_CHAT_PROVIDER_KEYS } from './crmChatProviderKey'

const DELETE_SUPPORTED_PROVIDERS = new Set<string>(CRM_CHAT_PROVIDER_KEYS)

/**
 * Wazzup delete (docs): WhatsApp, Telegram, Telegram Bot, MAX, MAX bot.
 * channel.type → whatsapp/wapi · telegram/tgapi · max/maxbot.
 */
const WAZZUP_DELETE_SUPPORTED_CHANNEL_TYPES = new Set([
  'whatsapp',
  'wapi',
  'telegram',
  'tgapi',
  'max',
  'maxbot',
])

const hasProviderMessageId = (value: string | null | undefined): boolean => {
  if (value == null) return false
  return String(value).trim().length > 0
}

export const isWazzupChannelDeleteSupported = (
  channelType: string | null | undefined,
): boolean => {
  const normalized = String(channelType ?? '')
    .trim()
    .toLowerCase()
  if (!normalized) return false
  return WAZZUP_DELETE_SUPPORTED_CHANNEL_TYPES.has(normalized)
}

/**
 * Кнопка «Удалить»: исходящее с id у провайдера.
 * `can_delete` с бэка нет — считаем на клиенте.
 * Для Wazzup — только каналы из whitelist (WhatsApp / Telegram / MAX).
 */
export const canDeleteCrmIntegrationMessage = (
  message: Pick<
    CrmIntegrationMessageDisplay,
    | 'direction'
    | 'providerMessageId'
    | 'externalMessageId'
    | 'sendState'
    | 'clientId'
  >,
  provider: CrmChatProviderKey | string,
  options?: { wazzupChannelType?: string | null },
): boolean => {
  if (!DELETE_SUPPORTED_PROVIDERS.has(String(provider))) {
    return false
  }
  if (provider === 'wazzup') {
    if (!isWazzupChannelDeleteSupported(options?.wazzupChannelType)) {
      return false
    }
  }
  if (message.direction !== 'outgoing') {
    return false
  }
  // Локальные pending / ошибка отправки — без delete.
  if (message.sendState === 'sending' || message.sendState === 'error') {
    return false
  }
  if (message.clientId && !message.providerMessageId && !message.externalMessageId) {
    return false
  }
  return (
    hasProviderMessageId(message.providerMessageId) ||
    hasProviderMessageId(message.externalMessageId)
  )
}
